// @flow

import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ResponsiveContainer, ReferenceDot, Bar, YAxis, XAxis, ComposedChart } from 'recharts';

type ChartProps = {
  result: number,
  low: number,
  high: number
} & WithTranslation

type LabelProps = {
  x: number,
  width: number,
  textAnchor: string
}

// constants for the ObservationChart
const containerWidth = '100%';
const containerHieght = 66;
const barSize = 20;
const dotRadius = 10;
const colourOutsideRange = '#EF1EA4';
const colorInsideRange = '#672BC2';
const layoutDirection = 'vertical';

// constants for the CustomizedLabel
const labelYAxis = 70;
const labelDYAxis = -8;

// customized label we create to override
// bar label's default behaviour and match
// our design - see: http://recharts.org/en-US/api/Bar
const CustomizedLabel = ({ x, width, textAnchor }: LabelProps) => {
  const newX = x + (width / 2);
  return (
    <text
      x={newX}
      y={labelYAxis}
      dy={labelDYAxis}
      textAnchor='middle'
    >{textAnchor}</text>);
};

class ObservationChart extends Component<ChartProps> {
  props: ChartProps;
  render() {
    const { t } = this.props;
    const result = parseFloat(this.props.result);
    const low = this.props.low ? parseFloat(this.props.low) : 0;
    const high = this.props.high ? parseFloat(this.props.high) : result + Math.abs(result - low);
    const min = low - (high * 0.1);
    const max = high + (high * 0.1);
    const barBounds = [];
    if (this.props.low) {
      barBounds.push(low);
    } else {
      barBounds.push(min);
    }
    if (this.props.high) {
      barBounds.push(high);
    } else {
      barBounds.push(max);
    }
    // constants for the ObservationChart dependant on props
    const chartData = [{ name: t('resourceTypes:sentence.observation'), range: barBounds }];
    const dotColor = (result < low || result > high) ?
      colourOutsideRange : colorInsideRange;

    const ticks = [];
    if (this.props.low) ticks.push(low);
    if (this.props.high) ticks.push(high);
    return (
      <div className='record-observation__gradient-border'>
        {/* gradient for the bar graph */}
        <svg id='graph-background-gradient' aria-hidden='true' focusable='false'>
          <linearGradient id='my-cool-gradient' x2='1' y2='1'>
            <stop stopColor='#DCC5FF' />
            <stop offset='1' stopColor='#BBCEFE' />
          </linearGradient>
        </svg>
        {/* end of gradient for the bar graph */}
        <div className='record-observation__chart'>
          <ResponsiveContainer width={containerWidth} height={containerHieght} layout={layoutDirection}>
            <ComposedChart data={chartData} layout={layoutDirection}>
              <XAxis
                domain={[min < result ? min : result - (high * 0.1), max > result ? max : result + (result * 0.1)]}
                type='number'
                ticks={ticks}
                axisLine={false}
              />
              <YAxis hide dataKey='name' type='category' />
              <Bar
                isAnimationActive={false}
                label={<CustomizedLabel textAnchor={t('observationChart:normal_range')} />}
                dataKey='range'
                fill='url(#my-cool-gradient)'
                barSize={barSize}
              />
              <ReferenceDot
                x={result}
                y={t('resourceTypes:sentence.observation')}
                r={dotRadius}
                alwaysShow
                isFront
                fill={dotColor}
                stroke='none'
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default withTranslation(['observationChart', 'resourceTypes'])(ObservationChart);



// WEBPACK FOOTER //
// ./src/components/observation-chart.js